import { useState } from "react";

export interface SetHook<T> {
  values: T[];
  has: (value: T) => boolean;
  remove: (value: T) => void;
  add: (values: T[]) => void;
}

export function useSet<T>(values: T[]): SetHook<T> {
  const [state, setState] = useState<Set<T>>(new Set(values));

  function has(value: T): boolean {
    return state.has(value);
  }

  function remove(value: T) {
    state.delete(value);
    setState(new Set(Array.from(state)));
  }

  function add(values: T[]) {
    values.forEach((value) => state.add(value));
    setState(new Set(Array.from(state)));
  }

  return {
    values: Array.from(state),
    has,
    remove,
    add,
  };
}
